<template>
<div>

<div class="row">
  <div class="col-6">
    <img :src="baseUrl + value.image" alt="imagen" class="imagenTabla">
    </div>
  <div class="col-6 pt-2 pt-md-0 d-flex align-items-start justify-content-end flex-column ">
    <div>{{ value.imageOriginalName }}</div>
    <div v-if="value.imageSize">Tamaño: {{ value.imageSize }}</div>
    <div><a class="text-danger" @click="fileRemoved">Eliminar imagen</a></div>
  </div>
</div>

</div>
</template>

<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_API_URL_STATIC_ASSETS
    }
  },
  props: ['value'],
  methods: {
    fileRemoved () {
      this.$emit('fileRemoved')
    }
  }
}
</script>

<style lang="sass" scope>
.imagenTabla
  width: 100%
</style>
